import OurTeamPage from './our-team-page'
export default OurTeamPage;